import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d856a54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-box" }
const _hoisted_2 = {
  class: "content",
  style: {"display":"flex","height":"100%"}
}

import { computed, onMounted, ref } from "vue";
import chat from "@/components/message/chat.vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { gaEvent } from "@/utils/format";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import leftNoTabs from "@/components/message/leftNoTabs.vue";
import rightContent from "@/components/message/rightContent.vue";
import chatContentItem from "@/components/message/chatContentItem.vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";






export default /*#__PURE__*/_defineComponent({
  __name: 'messages',
  props: {
  lastUpdateTime: {
    type: String
  }
},
  setup(__props) {

const { t } = useI18n();
const props = __props;
let startTime = ref('')// 开始时间
let endTime = ref('')//结束时间
let accessTime = ref([]) //时间数组
const store = useStore();
const isSync = ref(false)//是否点击同步按钮
const showUpdateTime = ref(false)
const isVibe = computed(() => !store.state.isVibe);
// 最后更新时间
let lastUpdateTime = ref(0)
const currentMonitorApp = computed(() => store.state.currentMonitorApp);
const isShowMore750 = computed(() => store.state.isShowMore750);
const isShowMessageLeft = computed(() => store.state.generalAppStore.isShowMessageLeft)
const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  console.log("点击同步");
  isSync.value = true
}
//接收到的时间
const updateHeaderDate = (value: any) => {
  startTime.value = value[0]
  endTime.value = value[1]
  accessTime.value = value
  console.log('接收到的时间：', startTime.value, endTime.value);
};
const sendlastTime = (e: any) => {
  lastUpdateTime.value = e
  isSync.value = false
  if (!e) {
    showUpdateTime.value = false
  } else {
    showUpdateTime.value = true

  }
  console.log("leftConetents来的时间：", e);
}
// console.log(currentMonitorApp.value, "currentMonitorApp");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Messages'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: updateHeaderDate,
      onUpdateInfo: updateInfo
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(leftNoTabs, {
          accessTime: _unref(accessTime),
          isSync: isSync.value,
          onSendlastTime: sendlastTime
        }, {
          phoneItem: _withCtx(({ item }) => [
            _renderSlot(_ctx.$slots, "phoneItem", {
              item: item.item
            })
          ]),
          _: 3
        }, 8, ["accessTime", "isSync"]), [
          [_vShow, isShowMore750.value || (!isShowMore750.value && isShowMessageLeft.value)]
        ]),
        _withDirectives(_createVNode(rightContent, { accessTime: _unref(accessTime) }, {
          chatContentItem: _withCtx(({ msgObj }) => [
            _createVNode(chatContentItem, _normalizeProps(_guardReactiveProps(msgObj)), null, 16)
          ]),
          _: 1
        }, 8, ["accessTime"]), [
          [_vShow, isShowMore750.value || (!isShowMore750.value && !isShowMessageLeft.value)]
        ])
      ])
    ])
  ], 64))
}
}

})